import { AggPageFormContext } from 'context/page-form-context';
import { PagesContext } from 'context/pages-context';
import { ChangeEvent, useContext } from 'react';

import { AggPageComponent } from '../../../../common/constants/enums';
import { FormItem } from '../../../../common/ui/formItem';
import { Input } from '../../../../common/ui/Input';

export const SlugInput = () => {
  const { error } = useContext(PagesContext);
  const { changeSlug, slug } = useContext(AggPageFormContext);

  const inputHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    changeSlug(value);
  };

  return (
    <div className="flex-column align-start w-100">
      <FormItem className="w-100" label="Slug" message={error[AggPageComponent.Slug]}>
        <Input
          // iconAfter={<CopyIcon onClick={() => utilCopyToClipboard(textBefore + slug)} />}
          invalid={!!error[AggPageComponent.Slug]}
          onChange={inputHandler}
          // textBefore={textBefore}
          value={slug}
        />
      </FormItem>
    </div>
  );
};
